import { cronosClient } from "@/config/client"

interface UpdateWeeklyObjectiveData {
  date: string
}

export function update(id: string, data: UpdateWeeklyObjectiveData) {
  return cronosClient.put<void, UpdateWeeklyObjectiveData>(`/v1/weekly-objectives/${id}/week`, data)
}
